import React, { useState } from "react";

const Tooltip = ({
  children,
  text,
  position = "top",
  className = "",
  delay = 0,
  disabled,
  customStyle = {},
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const tooltipPositions = {
    top: "tooltip--top",
    bottom: "tooltip--bottom",
    left: "tooltip--left",
    right: "tooltip--right",
    bottomRight: "tooltip--bottom-right",
    bottomLeft: "tooltip--bottom-left",
    topRight: "tooltip--top-right",
    topLeft: "tooltip--top-left",
  };

  return disabled ? (
    children
  ) : (
    <div
      className={`tooltip-wrapper ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`tooltip ${tooltipPositions[position] || tooltipPositions.top}`}
          style={{
            transitionDelay: `${delay}ms`,
            ...customStyle,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
